export default __webpack_public_path__ + "static/media/coletor-dados.c13df446.png";